var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default_modal"},[_c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.show,"before-close":_vm.onClose,"width":_vm.width,"fullscreen":_vm.fullscreen,"custom-class":"modal-default"},on:{"update:visible":function($event){_vm.show=$event}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }